import type { ReactNode } from "react";

/**
 * The section is a two-column grid: the heading sits in the first cell and the
 * tracklist's summary (track count · duration, rendered by `Tracklist`) lands in
 * the second cell of the same row. Everything else spans both columns.
 */
export const TRACKLIST_SUMMARY_CLASS = "col-start-2 row-start-1 justify-self-end text-right";
export const TRACKLIST_BODY_CLASS = "col-span-2 min-w-0";

interface TracklistSectionProps {
  title: string;
  hasTracks: boolean;
  emptyLabel: string;
  children: ReactNode;
}

export function TracklistSection({
  title,
  hasTracks,
  emptyLabel,
  children,
}: TracklistSectionProps) {
  return (
    <section
      className="grid grid-cols-[minmax(0,1fr)_auto] items-baseline gap-x-4 gap-y-5"
      aria-labelledby="catalog-tracklist-title"
    >
      <h2
        id="catalog-tracklist-title"
        className="col-start-1 row-start-1 text-2xl font-bold tracking-tight md:text-[1.75rem]"
      >
        {title}
      </h2>
      {hasTracks ? (
        children
      ) : (
        <p className={`py-12 text-center text-muted-foreground ${TRACKLIST_BODY_CLASS}`}>
          {emptyLabel}
        </p>
      )}
    </section>
  );
}
